module.exports = __webpack_public_path__ + "assets/4145cdc6dbc9c6254e49aa7806375426.png";